/* @flow */
import _ from 'lodash';
import Entity from 'lib/Entity';
import Group from 'entities/Group';

class Widget extends Entity {
  parse(response: Object) {
    const widget = _.clone(response);

    if (widget['group']) {
      widget['group'] = Group.fromJSON(widget['group']);
    }

    return widget;
  }

  getGroup(): ?Group {
    return this.get('group');
  }

  getClassName(): string {
    const group = this.getGroup();
    return group ? group.getName() : 'All classes';
  }

  getScriptUrl(): string {
    return this.get('script_url');
  }

  getGadgetUrl(): string {
    return this.get('gadget_url');
  }

  getWidgetUrl(): string {
    return this.get('widget_url');
  }

  isAllClassesWidget(): boolean {
    return !!this.getGroup() === false;
  }
}

export default Widget;
